import { EVENTS } from '../../../lib/constants';
import HELPERS from '../../../lib/globals/helpers/Helpers';

class QuestData {
	static processQuest(data) {
		let items = [];
		let total_progress = 0;
		let status = '';
		let step = false;
		for (let i = 0; i < data.items.length; i++) {
			let isCompleted = false;
			let prize = QuestData.getPrizeByID(data.prizes, data.items[i].prize);
			if (data.progresses[i] >= data.items[i].count) {
				total_progress++;
				isCompleted = true;
			}
			if (data.claimed[i] === 0) {
				status = 'active';
			}
			if (data.claimed[i] > 0) {
				status = 'inprogress';
			}
			if (data.claimed[i] >= prize.count) {
				status = 'completed';
			}
			if (prize.count > 1) {
				step = true;
			} else {
				step = false;
			}
			items.push({
				item: data.items[i],
				prize: prize,
				progress: data.progresses[i],
				claimed: data.claimed[i],
				isCompleted: isCompleted,
				win: data.wins[i],
				status: status,
				step: step
			});
		}
		HELPERS.dispatchCustomEvent(EVENTS.QUEST_CAN_CLAIM, {
			total_progress: total_progress
		});
		return {
			timer: data.timer,
			seconds_left: data.seconds_left,
			status: data.status,
			items: items,
			total_progress: total_progress
		};
	}

	static getPrizeByID(prizes, id) {
		for (let i = 0; i < prizes.length; i++) {
			if (prizes[i].id === id) {
				return prizes[i];
			}
		}
		return null;
	}
}

export default QuestData;
